import { Component, Output, EventEmitter } from '@angular/core';
import { DockModeService } from '../services/dock-mode.service';

@Component({
  selector: 'app-step1-list',
  templateUrl: './step1-list.component.html',
  styleUrls: ['./step1-list.component.scss']
})
export class Step1ListComponent {
  @Output() step1Editer = new EventEmitter();

  step1Edited(value: string) {
    this.step1Editer.emit({ name: value });
  }

  constructor(public dockMode: DockModeService) {}
}



// WEBPACK FOOTER //
// ./src/app/step1-list/step1-list.component.ts